var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"iframe",staticClass:"reward",attrs:{"src":_vm.rewardUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }